export default "__VITE_ASSET__B4WKMSog__"